<template>
  <div class="row">
    <div class="col-md-3 col-sm-12 mt-1">
      <div style="display: inline-flex">
        <div>
          <p class="font-weight-bold mt-4 pt-3 pl-5">
            {{ item.groupName }}
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-3 col-sm-12 mt-1">
      <div class="d-flex flex-column">
        <span class="data-title">Puesto:</span>
        <span class="data-content">
          {{ item.position }}
        </span>
      </div>
    </div>
    <div class="col-md-2 col-sm-12 mt-1">
      <div class="d-flex flex-column">
        <span class="data-title">Nombre:</span>
        <span class="data-content">
          {{ item.fullName }}
        </span>
      </div>
    </div>
    <div class="col-md-3 col-sm-12 mt-1">
      <div class="d-flex flex-column">
        <span class="data-title">Tipo de Participación:</span>
        <span class="data-content">
          {{ item.participationType }}
        </span>
      </div>
      <div v-if="item.alternateParticipationTypeId" class="mt-2">
        <div class="d-flex flex-column">
          <span class="data-title">Tipo de Participación Alterna:</span>
          <span class="data-content">
            {{ item.alternateParticipationType }}
          </span>
        </div>
      </div>
    </div>
    <hr class="divider-horizontal" />
  </div>
</template>

<script>
export default {
  name: "ParticipantSignatureRow",
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
 
  }
};
</script>
<style scoped>
.dot {
  border-radius: 50%;
  display: inline-block;
  opacity: 1;
  background: #fff 0 0 no-repeat padding-box;
  box-shadow: 0 3px 6px #00000029;
}
.text-red {
  color: #c9545e;
}
.text-center {
  text-align: center;
}
.drop-item {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.dropdown-item {
  font: Bold 16px/19px Lato;
}

.divider-horizontal {
  border: 0.5px solid #e2e2e2;
  position: relative;
  top: 12px;
  width: 90%;
}
.orange-icon {
  color: #ff7058;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: "Lato", sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  display: block;
  width: 100%;
}
.dropdown-menu-width {
  width: 91%;
}
@media (min-width: 992px) {
  .btn-dropdown-actions {
    /* width: 4.5rem; */
    font-size: 0.7rem;
    margin-right: 0px;
    display: block;
    width: 100%;
  }
}

@media (min-width: 1200px) and (max-width: 1440px) {
  .btn-dropdown-actions {
    font-size: 0.9rem;
    margin-right: -8px;
  }
}

@media (min-width: 1440px) and (max-width: 1920px) {
  .btn-dropdown-actions {
    font-size: 0.9rem;
    /* width: 7.4375rem; */
  }
}
.input-label {
  font: Bold 0.825rem Lato !important;
}
</style>
